import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRAND_DELETE_RESOURCE = "brand" as const;
export const BRAND_DELETE_API_PATH = `/v1/${BRAND_DELETE_RESOURCE}/{uuid}` as const;

export type BrandResponse =
  paths[typeof BRAND_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useBrandDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BrandResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const response = await alphartisApiAxios.delete<BrandResponse>(`/v1/${BRAND_DELETE_RESOURCE}/${uuid}`, {
        params: { force },
      });
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRAND_DELETE_RESOURCE],
      });
    },
  });
};
